import { render, staticRenderFns } from "./CheckSiteVersionLite.vue?vue&type=template&id=40b8a63d&scoped=true"
import script from "./CheckSiteVersionLite.vue?vue&type=script&lang=js"
export * from "./CheckSiteVersionLite.vue?vue&type=script&lang=js"
import style0 from "./CheckSiteVersionLite.vue?vue&type=style&index=0&id=40b8a63d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b8a63d",
  null
  
)

export default component.exports